import { render, staticRenderFns } from "./MainBalance.vue?vue&type=template&id=af7097a6&scoped=true"
import script from "./MainBalance.vue?vue&type=script&lang=js"
export * from "./MainBalance.vue?vue&type=script&lang=js"
import style0 from "./MainBalance.vue?vue&type=style&index=0&id=af7097a6&prod&lang=scss&scoped=true"
import style1 from "./MainBalance.vue?vue&type=style&index=1&id=af7097a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7097a6",
  null
  
)

export default component.exports